import type { NotificationType } from '../types/notification.types'

/**
 * Texto de la fila de un grupo de novedades, por tipo (con plural `count`). Mapa tipado: un
 * tipo de Novedades nuevo sin texto cae al genérico.
 */
const GROUP_KEYS: Partial<Record<NotificationType, string>> = {
  NEW_SESSION_NEARBY: 'notifications.group.NEW_SESSION_NEARBY',
  STORE_EVENT_NEARBY: 'notifications.group.STORE_EVENT_NEARBY',
  FAVORITE_GAME_SESSION: 'notifications.group.FAVORITE_GAME_SESSION',
  FOLLOWED_STORE_EVENT: 'notifications.group.FOLLOWED_STORE_EVENT',
  VENUE_SESSION_CREATED: 'notifications.group.VENUE_SESSION_CREATED',
  PLAY_INTENT_GROUP: 'notifications.group.PLAY_INTENT_GROUP',
  PLAY_INTENT_SESSION: 'notifications.group.PLAY_INTENT_SESSION',
  COMMUNICATION: 'notifications.group.COMMUNICATION',
}

export function notificationGroupKey(type: string): string {
  return GROUP_KEYS[type as NotificationType] ?? 'notifications.group.other'
}
